import { Accepts, Types } from "@citychallenge/common";
import { TransTokens } from "../../../i18n";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class ChecklistProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.Text) public question?: Types["Text"];
  @Inlet(Accepts.IdAndLabelList)
  public checklistItems?: Types["IdAndLabelList"];
  @Inlet(Accepts.Boolean) public isRequired?: Types["Boolean"];

  @Inlet(Accepts.Number)
  public minAnswers?: Types["Number"];

  @Inlet(Accepts.Number)
  public maxAnswers?: Types["Number"];
}

export const ChecklistDefinition = defineElement("checklist", ChecklistProps, {
  versionRequired: "0.9.0",
});

export const checklistTokens = TransTokens.create({
  multiplePossible: "It's possible to select multiple answers.",
});
